import { all } from 'redux-saga/effects';
import * as privacySettingsSaga from './containers/privacy-settings/saga';
import * as assignActivityPreferenceSaga from './containers/activity-assign-preference/saga';

function* mainSaga() {
    yield all([
        privacySettingsSaga.saveSettingPreferencesSaga(),
        privacySettingsSaga.getUserSettingsSaga(),
        assignActivityPreferenceSaga.getAssignActivityPreferencesSaga(),
        assignActivityPreferenceSaga.saveActivityAssignPreferencesSaga(),
        assignActivityPreferenceSaga.resetActivityAssignPreferencesSaga()
    ]);
}

export default mainSaga;



// WEBPACK FOOTER //
// ./app/main-saga.js